import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import builderConfig from '../../../model-map'
import {fetchEntries} from '@builder.io/sdk-react'
import {useInfiniteQuery} from '@tanstack/react-query'
import {useBuilderPagination} from '@/builder/hooks/useBuilderPagination'
import {isProduction} from '@/utils/common'
import {TEN_MINUTES_IN_MS} from '@/utils/constants'

export const useArticlePagination = ({
    perPageLimit,
    maxQueryLimit = 100,
    articleTopicId = '',
    queryAllArticles,
    filterFunction
}) => {
    const config = getConfig()

    const articleDataQuery = articleTopicId
        ? {
              'data.topics.topic.id': articleTopicId
          }
        : {}

    const fetchArticles = async ({pageParam = 1}) => {
        return await fetchEntries({
            apiKey: config.app.builder.api,
            model: builderConfig.learningCenterArticle,
            query: {...articleDataQuery, published: 'published'},
            limit: maxQueryLimit,
            staleTime: 0,
            offset: (pageParam - 1) * maxQueryLimit
        })
    }

    const {
        data: articlesData,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
        error
    } = useInfiniteQuery({
        queryKey: ['learning-center-article-grid', articleTopicId],
        queryFn: fetchArticles,
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {
            if (!lastPage || !Array.isArray(lastPage) || lastPage?.length < maxQueryLimit) {
                return undefined
            }
            return allPages.length + 1
        },
        // 10 min
        staleTime: isProduction ? TEN_MINUTES_IN_MS : 0,
        enabled: queryAllArticles || !!articleTopicId
    })

    const {
        showNextEntries,
        showAll,
        getAllEntries,
        totalItems,
        displayedItems,
        allEntriesDisplayed
    } = useBuilderPagination({
        perPageLimit,
        data: articlesData,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isBuilderQuery: true,
        filterFunction
    })

    return {
        showNextEntries,
        showAll,
        getAllEntries,
        totalItems,
        displayedArticles: displayedItems,
        displayedArticlesCount: displayedItems?.length,
        allEntriesDisplayed,
        isLoading,
        error: error
    }
}
